<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <div class="row">
            <div class="column medium-3 text-right float-right">
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button tag="router-link" :to="'/panel/facturen/geescaleerd'" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-9">
                <h1>Dossier {{ record.number }}</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <form class="form red-top">
                    <b-tabs size="is-medium">
                        <b-tab-item label="Algemeen">
                            <table class="table is-fullwidth is-striped">
                                <tbody>
                                    <tr>
                                <td width="200"><strong>Escalatie datum</strong></td>
                                <td>{{ moment(record.created_at).format('DD-MM-YYYY') }}</td>
                            </tr>
                            <tr>
                                <td width="200"><strong>Status</strong></td>
                                <td>
                                    {{ invoiceStatus(record.status) }}
                                </td>
                            </tr>
                            <tr>
                                <td width="200"><strong>Klant</strong></td>
                                <td>
                                    <router-link v-if="record.customer" :to="{ name: 'CustomersRecord', params: { id: record.customer.id } }">{{ hideSensitiveData ? '*********' : `${record.customer.firstname} ${record.customer.lastname}` }}</router-link>
                                    <span v-else>-</span>
                                </td>
                            </tr>
                            <tr>
                                <td width="200"><strong>Totaal bedrag</strong></td>
                                <td>
                                    <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                                    <span v-else>&euro;&nbsp;{{ record.total }}</span>
                                </td>
                            </tr>
                                </tbody>
                            </table>
                        </b-tab-item>
                    </b-tabs>
                </form>
            </div>
        </div>

        <!-- Facturen in deze escalatie -->
        <div class="row">
            <div class="column">
                <form class="form verticalpadding">
                    <h3>Facturen in dit dossier</h3>
                    <b-table
                        :data="record.invoices"
                        :striped="true"
                        :loading="loading"
                        :mobile-cards="true"
                    >
                        <template>
                            <b-table-column v-slot="props" field="number" label="Factuur nr." width="130">
                                {{ props.row.number }}
                            </b-table-column>

                            <b-table-column v-slot="props" field="invoice_date" label="Datum">
                                {{ moment(props.row.invoice_date).format('DD-MM-YYYY') }}
                            </b-table-column>

                            <b-table-column v-slot="props" field="status" label="Status" width="100">
                                <InvoiceStatus
                                    :id="props.row.id"
                                    :status="props.row.status"
                                    :send_at="props.row.send_at"
                                    :payments="props.row.invoice_payments"
                                    :type="props.row.type"
                                    :showEscalationDropdown="true"
                                    @reload="loadEscalation"
                                />
                            </b-table-column>

                            <b-table-column v-slot="props" field="uuid" label="Escalatiepakket">
                                <a :href="`/export/escalation/${props.row.escalation.id}/${props.row.escalation.uuid}?user=${user.id}`" v-if="props.row.escalation.uuid" @click="downloadEscalation" target="_blank">Download</a>
                                <span v-else>-</span>
                            </b-table-column>

                            <b-table-column v-slot="props" field="total" label="Bedrag" width="180" numeric>
                                <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                                <span v-else>&euro;&nbsp;{{ props.row.total }}</span>
                            </b-table-column>

                            <b-table-column v-slot="props" numeric width="100">
                                <!-- <b-button tag="router-link" type="is-dark" size="is-small"
                                    :to="{ name: 'InvoicesRecord', params: {type: 'recent', id: props.row.id} }">
                                    Bekijken
                                </b-button> -->
                                <InvoiceOptionsDropdown
                                    :type="type"
                                    :record="props.row"
                                    @reloadInvoices="loadEscalation"
                                />
                            </b-table-column>
                        </template>
                    </b-table>
                </form>
            </div>
        </div>

        <!-- Boxen -->
        <div class="row" v-if="record.boxes && record.boxes.length">
            <div class="column">
                <form class="form verticalpadding">
                    <h3>Product<span v-show="record.invoice_products && record.invoice_products.length > 1">en</span></h3>
                    <ProductsSummary
                        :products="record.invoice_products"
                        :showTotals="true"
                        :record="record"
                        :editingProducts="editingProducts"
                    />
                </form>
            </div>
        </div>

        <!-- Communicatie log -->
        <CommunicationLogs
            type="escalation"
            :logs="invoice_logs"
            :loading="loading"
            :viewRelatedButton="relatedLogs"
            @loadEscalationLogs="loadEscalationLogs"
            @toggleRelated="toggleRelated"
        />
    </div>
</template>

<script>
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import toastMixin from '@/mixins/toastMixins.js'
import filterMixins from '@/mixins/filterMixins.js'
import InvoiceStatus from './components/InvoiceStatus.vue'
import InvoiceStatusMixin from '@/mixins/InvoiceStatusMixin'
import escalationMixin from '@/mixins/escalationMixin'
import EscalationOptionsDropdown from './components/EscalationOptionsDropdown'
import CommunicationLogs from '@/vue/CommunicationLogs.vue'
import ProductsSummary from '@/vue/products/components/ProductsSummary.vue'
import InvoicesTable from './components/InvoicesTable.vue'
import InvoiceOptionsDropdown from './components/InvoiceOptionsDropdown'

export default {
    name: 'EscalationRecord',

    components: {
        EscalationOptionsDropdown,
        CommunicationLogs,
        ProductsSummary,
        InvoicesTable,
        InvoiceStatus,
        InvoiceOptionsDropdown
    },

    mixins: [
        formvalidationMixin,
        toastMixin,
        filterMixins,
        InvoiceStatusMixin,
        escalationMixin
    ],

    data() {
        return {
            type: 'escalation',
            loading: false,
            record: {},
            invoice_logs: [],
            editingProducts: false,
            relatedLogs: false
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    created() {
        this.loadEscalation()
        this.loadEscalationLogs()
    },

    methods: {
        loadEscalation() {
            this.loading = true

            if (this.relatedLogs) {
                this.loadEscalationLogs()
            }

            axios.get('/api/escalations/' + this.$route.params.id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.record = response.data;
                this.loading = false;
                this.loadEscalationLogs();
            }).catch((error) => {
                this.showError('Error: Escalatie kan niet geopend worden!')
                console.error(error)
                this.$router.push({name: 'InvoiceOverview'})
            });
        },

        loadEscalationLogs() {
            this.loading = true

            axios.get('/api/escalations/' + this.$route.params.id + '/logs?showRelated=' + this.relatedLogs, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.invoice_logs = response.data.invoice_logs
                this.loading = false
            }).catch((error) => {
                this.showError('Error: Logs kunnen niet worden geladen!')
                console.error(error)
            });
        },

        toggleRelated () {
            this.relatedLogs = !this.relatedLogs
            this.loadEscalationLogs()
        },

        downloadEscalation () {
            this.loading = true

            setTimeout(() => {
                this.loading = false

                if (this.relatedLogs) {
                    this.loadEscalationLogs()
                }
            }, 1000)
        }
    }
}
</script>